import firebase from 'firebase/app';
import { DateTime } from "luxon";

class Orders {
	getOrders() {
		return firebase
			.database()
			.ref(process.env.VUE_APP_FIREBASE_ORDERS_COLLECTION + '/')
			.orderByChild('userAccount');
	}

	createOrder(newOrder, callback) {
		var newOrderKey = firebase
			.database()
			.ref()
			.child(process.env.VUE_APP_FIREBASE_ORDERS_COLLECTION)
			.push().key;
		var dt = DateTime.now();
		newOrder['timeStamp'] = dt.toLocaleString(DateTime.DATETIME_MED);
		var orderData = {};
		orderData[
			process.env.VUE_APP_FIREBASE_ORDERS_COLLECTION + '/' + newOrderKey
		] = newOrder;
		return firebase
			.database()
			.ref()
			.update(orderData, callback);
	}
}

// Define as singleton
const instance = new Orders();
Object.freeze(instance);

export default instance;
